"use strict";
/**
 *
 * https://data.iana.org/TLD/tlds-alpha-by-domain.txt
 *
 * # Version 2023053100, Last Updated Wed May 31 07:07:01 2023 UTC
 *
 * Management of the DNS Root Zone (assignments of ccTLDs and gTLDs) along with other
 * functions such as the .int and .arpa zones.
 *
 * We are one of the Internet’s oldest institutions, with the IANA functions dating back to the 1970s.
 * Today the services are provided by Public Technical Identifiers,
 * a purpose-built organization for providing the IANA functions to the community.
 *
 * PTI is an affiliate of ICANN, an internationally-organised non-profit organisation set up by the
 * Internet community to coordinate our areas of responsibilities.
 *
 * To pull the most up to date list, please visit https://github.com/mastermunj/global-tld-list
 */
exports.__esModule = true;
exports.isValidTLD = void 0;
var tld_1 = require("./tld");
var isValidTLD = function (email) {
    var extractedTLD = email.split('.').pop() || '';
    return tld_1.TLDS.has(extractedTLD.toLowerCase());
};
exports.isValidTLD = isValidTLD;
